import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { createAction } from 'shared/util/utility';
import NavItem from './navItem';
import * as actionTypes from 'store/action-types';
import { _adminNav } from './_nav';
import { Logo } from '../../icons/icons';

const SideNav = () => {
	const [openStatus, setOpenStatus] = useState<{ [key: string]: boolean }>({});
	const [isMini, setIsMini] = useState<boolean>(false);
	const dispatch = useDispatch();
	useEffect(() => {
		setIsMini(document.body.classList.contains('mini-navbar'));
	}, []);
	const hideSidebarNoop = () => {
		// intentional no-op (NavItem should not toggle the sidebar)
		void 0;
	};

	// Only toggle on explicit hamburger click
	const handleHamburgerClick = (e: React.MouseEvent) => {
		// Avoid bubbling to parent handlers that might toggle again
		e.stopPropagation();
		toggleSidebar();
	};

	const toggleIsOpen = (name: string) => {
		if (openStatus[name]) {
			setOpenStatus({ [name]: false });
		} else {
			setOpenStatus({ [name]: true });
		}
	};
	const toggleSidebar = () => {
		const body = document.body;
		if (!body) return;
		const collapsed = body.classList.contains('mini-navbar');
		if (collapsed) {
			body.classList.remove('mini-navbar');
			setIsMini(false);
		} else {
			body.classList.add('mini-navbar');
			setIsMini(true);
		}
	};

	const renderSideNav = () => {
		dispatch(createAction(actionTypes.NO_ACTION));
	};

	return (
		<nav className={`navbar-default navbar-static-side ${isMini ? 'mini-navbar' : ''}`} role='navigation'>
			<button
				type='button'
				className='navbar-back-btn'
				onClick={handleHamburgerClick}
				aria-pressed={isMini}
				aria-label='Toggle sidebar'
			>
				<i className='bx bx-menu' />
			</button>
			<ul className='nav' id='side-menu'>
				<li className='nav-header cursor-pointer'>
					<h3 className='profile-element'>
						<div className='logo-wrapper'>
							<div className='logo'>
								<Logo />
							</div>
						</div>
					</h3>
				</li>
				<div className='line' />
				{_adminNav.map((menu, index) => (
					<NavItem
						isOpen={openStatus[menu.name] || false}
						hideSidebar={hideSidebarNoop}
						toggleIsOpen={toggleIsOpen}
						key={index}
						renderSideNav={renderSideNav}
						menu={menu}
					/>
				))}
			</ul>
		</nav>
	);
};

export default SideNav;
